export default "/aARB.e553677364c251736ecb3ec4b4cd2af8.png";